import { ServiceFetch } from '../service-fetch'

export default class StockSettingUserModel extends ServiceFetch {
    getStockSettingUserBy = (data) => this.authFetch({
        url: 'stock-setting-user/getStockSettingUserBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}